import { StatusGenericEnum, PlatformAccessEnum } from "@/core/enums";

interface StateInfo {
    color: string;
    label: string;
}


const stateMap: Record<StatusGenericEnum, StateInfo> = {
    [StatusGenericEnum.ACTIVE]: {
        color: "text-green-600",
        label: "Activo",
    },
    [StatusGenericEnum.INACTIVE]: {
        color: "text-gray-600",
        label: "Inactivo",
    },
    [StatusGenericEnum.DELETED]: {
        color: "text-red-600",
        label: "Eliminado",
    },
}

const platformAccessMap: Record<PlatformAccessEnum, StateInfo> = {
    [PlatformAccessEnum.WEB]: {
        color: "text-green-600",
        label: "Web",
    },
    [PlatformAccessEnum.MOBILE]: {
        color: "text-gray-600",
        label: "Móvil",
    },
    [PlatformAccessEnum.BOTH]: {
        color: "text-blue-600",
        label: "Ambos",
    },
}

export function getRoleStateInfo(state: string): StateInfo {
    const validStates = Object.values(StatusGenericEnum);
    if (!validStates.includes(state as StatusGenericEnum)) {
        return {
            color: "text-gray-600",
            label: "Desconocido",
        };
    }
    return stateMap[state as StatusGenericEnum];
}

export function getPlatformAccessInfo(platformAccess: string): StateInfo {
    const validPlatformAccesses = Object.values(PlatformAccessEnum);
    if (!validPlatformAccesses.includes(platformAccess as PlatformAccessEnum)) {
        return {
            color: "text-gray-600",
            label: "Desconocido",
        };
    }
    return platformAccessMap[platformAccess as PlatformAccessEnum];
}